<template>
  <div>
    <v-card>
      <v-card-title>Transmitir Guia a UPS</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-combobox
              v-model="cuenta"
              :items="cuentas"
              item-text="nombre"
              item-value="cuenta"
              label="Cuenta"
              append-icon="check_circle"
              return-object
              :disabled="disableAll"
            ></v-combobox>
            <div v-if="cuenta">{{ cuenta.cuenta }}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-checkbox
              v-model="enviarDatosCliente"
              label="Deseo transmitir los datos del cliente para la creación de la guia en UPS"
              :disabled="disableAll"
              @change="handleEnviarDatosChange()"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-combobox
              v-model="empresa"
              :items="empresas"
              item-text="empresa"
              item-value="id"
              label="Empresa"
              append-icon="mdi-office-building"
              return-object
              :disabled="disableAll"
              v-show="!enviarDatosCliente"
              clearable
            ></v-combobox>
          </v-col>
        </v-row>
        <!--v-row>
          <v-col cols="12" sm="12" md="12">
            <v-combobox
              v-model="servicio"
              :items="servicios"
              item-text="servicio"
              item-value="codigo"
              label="Servicio"
              append-icon="thumb_up"
              return-object
              :disabled="disableAll"
            ></v-combobox>
          </v-col>
        </v-row-->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer
        ><v-btn :disabled="disableAll" color="primary"  outlined @click="enviarUPS()">
          Enviar a UPS
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-overlay :value="overlay">
      <waiting />
    </v-overlay>
  </div>
</template>

<script>
import Waiting from '../components/Waiting.vue';
import apicon from '../plugins/apicon';
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  components: {
    Waiting,
  },
  created: function () {},
  data() {
    return {
      cuentas: [],
      cuenta: null,
      /*servicios: [
        { codigo: "01", servicio: "Next Day Air" },
        { codigo: "02", servicio: "2nd Day Air" },
        { codigo: "03", servicio: "Ground" },
        { codigo: "07", servicio: "Express" },
        { codigo: "08", servicio: "Expedited" },
        { codigo: "11", servicio: "UPS Standard" },
        { codigo: "12", servicio: "UPS Three-Day Select" },
        { codigo: "13", servicio: "Next Day Air Saver" },
        { codigo: "14", servicio: "UPS Next Day Air Early AM" },
        { codigo: "54", servicio: "UPS Worldwide Express Plus" },
        { codigo: "59", servicio: "UPS Second Day Air AM" },
        { codigo: "65", servicio: "UPS Saver" },
        { codigo: "70", servicio: "UPS Access Point Economy" },
        { codigo: "93", servicio: "UPS Sure Post" },
      ],*/
      //servicio: null,
      empresas: [],
      empresa: null,
      enviarDatosCliente: true,
      overlay: false,
      disableAll: false,
    };
  },
  methods: {
    fillCuentas: function () {
      apicon.getDataApi(apicon.getApiBaseUrl() + "cuentasups").then((result) => {
        this.cuentas = result;
      });
    },
    fillEmpresas: function() {
      apicon.getDataApi(apicon.getApiBaseUrl() + 'empresa').then((result) => {
        this.empresas = result;
      });
    },
    //Enviar guia a UPS
    enviarUPS: async function () {
      if (this.cuenta != null) {
        if (!this.enviarDatosCliente && this.empresa == null) {
          this.$swal("Por favor seleccione una empresa");    
        } else {            
            this.overlay = true;
            let id_empresa = this.empresa != null? this.empresa.id : 0;            
          await apicon.saveDataApi(apicon.getApiBaseUrl() + "enviarups", {
            id: this.id,
            cuenta: this.cuenta.cuenta,
            datosCliente : this.enviarDatosCliente, 
            id_empresa: id_empresa
            //servicio: this.servicio.codigo,
          }).then((result) => {
            console.log(result);
            this.overlay = false;
            if (result.ShipmentIdentificationNumber) {
              this.disableAll = true;
              this.$swal(
                "Se ha transmitido la información exitosamente su número de guía es : " +
                  result.ShipmentIdentificationNumber
              );
            } else if (result.Error) {
                this.$swal(
                  "UPS ha notificado el siguiente error : " +
                    result.Error
                );
            }
          });
        }
      } else {
        this.$swal("Por favor seleccione una cuenta para realizar el envío...");
      }
    },
    handleEnviarDatosChange: function(){
      if(!this.enviarDatosCliente){
        this.empresa = null;
      }
    },
  },
  mounted: function () {
    apicon.setAuthHeaders();
    this.fillCuentas();
    this.fillEmpresas();
  },
};
</script>